<template>
  <div>
    <div class="d-flex flex-wrap">
      <div id="map-wrapper" class="col-12 col-lg-8" style="position: relative">
        <FranceMapSvg :default-color="defaultColor" />

        <LongevityCard
          id="data-card"
          custom-class="data-card"
          v-show="currentHoveredId && hoveredDepartmentData"
          :department-data="hoveredDepartmentData"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import FranceMapSvg from "@/components/utils/FranceMapSvg";
import LongevityCard from "@/components/coach-manager/longevity/LongevityCard";

export default {
  components: {
    FranceMapSvg,
    LongevityCard,
  },

  props: {
    data: { type: Array, required: true },
    filters: {
      required: true,
      type: Object,
    },
    colorScheme: {
      type: String,
      default: "blue",
    },
  },

  data() {
    return {
      currentHoveredId: null,
      dataCardPositionIsSet: false,
    };
  },

  mounted() {
    this.setPathsListeners();
  },

  computed: {
    ...mapGetters({
      defaultColor: "getDefaultColorSetForStatsFranceMap",
    }),

    hoveredDepartmentData() {
      if (this.currentHoveredId) {
        return this.data.find(
          (departmentData) => departmentData.value === this.currentHoveredId,
        );
      }

      return {};
    },
  },

  methods: {
    setPathsListeners() {
      const paths = document.querySelectorAll("#map-wrapper path");

      paths.forEach((path) => {
        let id;
        let isIdf = false;

        if (path.id.startsWith("IDF")) {
          id = path.id.replace("IDF-", "");
          isIdf = true;
        } else {
          id = path.id.replace("FR-", "");
        }

        const data = [...this.data];

        const correspondingData = data.find(
          (departmentData) => departmentData.value === id,
        );

        if (correspondingData?.rank) {
          path.setAttribute("fill", this.getColor(correspondingData.rank));
        }

        path.addEventListener("mouseover", () => {
          if (!path.hasAttribute("stroke-width")) {
            path.setAttribute("stroke-width", isIdf ? ".6" : "3");
          }

          this.currentHoveredId = id;
        });

        path.addEventListener("mouseout", () => {
          if (path.hasAttribute("stroke-width")) {
            path.removeAttribute("stroke-width");
          }

          if (this.currentHoveredId === id) {
            this.currentHoveredId = null;
          }
        });
      });
    },

    getColor(rank) {
      switch (rank) {
        case "bad":
          return "#dc3545";

        case "middle":
          return "#ffc107";

        case "top":
          return "#28a745";
      }
    },

    setDataCardPosition() {
      const mapWrapper = document.querySelector("#map-wrapper");
      const dataCard = document.querySelector("#data-card");

      if (mapWrapper && dataCard) {
        mapWrapper.addEventListener("mousemove", (e) => {
          const wrapperInPage = mapWrapper.getBoundingClientRect();
          dataCard.style.left = e.x - wrapperInPage.x + "px";
          dataCard.style.top = e.y - wrapperInPage.y + "px";
        });

        this.dataCardPositionIsSet = true;
      }
    },
  },

  watch: {
    currentHoveredId(value) {
      if (value && !this.dataCardPositionIsSet) {
        this.setDataCardPosition();
      }
    },
  },
};
</script>

<style scoped>
.data-card {
  position: absolute;
  width: 300px;
  height: auto;
  transform: translate(-110%, -110%);
}
</style>
